<template>
  <div class="basic_wrap">
    <bsHeader
      :title="account.name"
      @backurl="$router.back()"
    />
    <div class="block_div auth_wrap">
      <form class="form">
        <div class="item">
          <input
            v-model.trim="email"
            type="text"
            class="inp"
            :placeholder="$t('auth.emailEmpty')"
            readonly
          >
        </div>
        <div class="item">
          <input
            v-model.trim="account.code"
            type="text"
            class="inp"
            :placeholder="$t('auth.emailCode')"
          >
          <van-count-down
            :time="time"
            class="btn get_captcha"
            @finish="timeCall"
          >
            <template v-slot="timeData">
              <span @click="sendcode">{{
                timeData.seconds > 0
                  ? timeData.seconds
                  : $t('auth.sendEmailCode')
              }}</span>
            </template>
          </van-count-down>
        </div>
        <div
          class="bind_wrap"
          style="margin-top: 10px;"
        >
          <div class="bind_item">
            <p class="item_name">
              {{ accountTips }}
            </p>
            <div class="block_div item_input">
              <van-field
                v-model="account.account"
                type="text"
                :placeholder="accountPlaceholder"
              />
            </div>
          </div>
          <div class="bind_item">
            <p class="item_name">
              {{ $t('wallet.qrcode') }}
            </p>
            <div class="block_div item_qrcode">
              <van-uploader
                v-model="fileList"
                multiple
                :max-count="1"
                class="upload"
                :max-size="2 * 1024 * 1024"
                :after-read="afterRead"
                :before-read="beforeRead"
                @oversize="onOversize"
              />
            </div>
          </div>
          <div
            v-if="account.img"
            class="bind_item"
            style="text-align: center;height: 100px;"
          >
            <img
              :src="account.img"
              style="width: 100px;height: 100px;vertical-align: middle;"
            > 
          </div>
          <div class="tips">
            <p class="tips1">
              <span>*</span>{{ $t('wallet.walletTips1') }}
            </p>
            <!-- <p class="tips2"><span>*</span>{{$t('wallet.walletTips2')}}</p> -->    
          </div>
          <div
            class="basic_btn btn"
            :class="account.name==''||account.account==''?'no_touch':''"
            @click="submit()"
          >
            {{ $t('wallet.bindNow') }}
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
	import Vue from 'vue';
	import bsHeader from '../../components/bsHeader.vue'
	import Fetch from '../../utils/fetch'
	import {
		CountDown,
		Checkbox,
		Field,
		CellGroup,
		Uploader,
		Toast
	} from "vant";

	Vue.use(Field).use(CellGroup).use(Uploader).use(Toast).use(CountDown).use(Checkbox);
	import Api from "../../interface/index";
	import axios from 'axios'
	export default {
		name: "WithdrawBank",
		components: {
			bsHeader
		},
		data() {
			return {
				data: [],
				fileList: [],
				account: {
					id: '',
					name: '',
					account: '',
					band_id:'',
					img: ""
				},
				data: {},
				time: 0,
				email: '',
				code:'',
				accountTips: "",
				accountPlaceholder: "",
				accountError: ""
			};
		},
		created() {
			if (window.plus) {
				plus.navigator.setStatusBarBackground('#FFFFFF');
				plus.navigator.setStatusBarStyle('dark');
			}
			this.$parent.footer('user', false);
		},
		mounted() {
			this.start();
			this.starts();
		},
		methods: {
			starts() {
				Fetch('/user/getAuthStatus').then((r) => {
					this.data = r.data; 
					this.email = r.data.email;
				});
			},timeCall() {
				this.is_send = false;
				this.time = 0;
			},
			start() {
				Fetch('/user/getWithdrawMethodById', {
					id: this.$router.history.current.params.code
				}).then(r => {
					if(r.data.withdraw.band){
						var band = r.data.withdraw.band;
						this.account.band_id = r.data.withdraw.band.id;
						this.account.account = r.data.withdraw.band.account;
						this.account.img = r.data.withdraw.band.img;
					}
					this.account.id = r.data.withdraw.id;
					this.account.name = r.data.withdraw.name;
					switch (r.data.withdraw.type) {
						case 1:
							this.accountTips = this.$t('wallet.address');
							this.accountPlaceholder = this.$t('wallet.addressPlaceholder');
							this.accountError = this.$t('wallet.addressError');
							break;
						case 2:
							this.accountTips = this.$t('wallet.alipay');
							this.accountPlaceholder = this.$t('wallet.alipayPlaceholder');
							this.accountError = this.$t('wallet.alipayError')
							break;
						case 3:
							this.accountTips = this.$t('wallet.wechat');
							this.accountPlaceholder = this.$t('wallet.wechatPlaceholder');
							this.accountError = this.$t('wallet.wechatError')
							break;
					}
				})
			},sendcode() {
				if (this.is_send) {
					return false;
				}
				if (!this.email) {
					this.$toast(this.$t('auth.emailEmpty'));
					return false;
				}
				var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
				if (!reg.test(this.email)) {
					this.$toast(this.$t('auth.emailError'));
					return false;
				}
				this.is_send = true;

				Fetch("/user/getEmailCode", {
					email: this.email
				}).then(() => {
					this.time = 60 * 1000;
					this.$toast({
						background: "#07c160",
						message: this.$t('auth.sendsuccess'),
					});
				}).catch(() => {
					this.is_send = false;
				});
			},
			submit() {
				if (this.account.account.length > 34 || this.account.account.length < 2) {
					this.$toast(this.accountError);
					return false;
				}
				if (this.account.img == "") {
					this.$toast(this.$t('wallet.qrcodeEmpty'));
					return false;
				}

				Fetch('/user/setWallet', {
					...this.account,
				}).then(r => {
					this.$router.replace('/user');
				})
			},
			onOversize(file) {
				this.$toast(this.$t('wallet.qrcodeLong'));
			},
			beforeRead(file) {
				if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
					this.$toast(this.$t('wallet.qrcodeError'));
					return false;
				}
				return true;
			},
			afterRead(file) {
				let formData = new FormData();
				formData.append('language', this.$i18n.locale || "en_us");
				formData.append('file', file.file);
				formData.append('token', localStorage.getItem('token'));
				Toast.loading({
					forbidClick: true,
					duration: 20000
				});
				axios.post(Api.commonUrl + "/api/user/imgUpload", formData).then((r) => {
					Toast.clear();
					if (r.data.code === 1) {
						this.account.img = r.data.data;
					} else {
						this.$toast(this.$t(r.data.info));
					}
				});
			}

		}
	};
</script>

<style lang="less" scoped>
	.bind_wrap {
		margin-top: 60px;

		.bind_item {
			padding: 20px 0 0 0;

			.item_name {
				color: #999;
				margin: 0 0 5px 5%;
			}

			.item_qrcode {
				height: 150px;
				text-align: center;
			}
		}

		.tips {
			line-height: 2;
			width: 92%;
			margin: 20px 0 0 4%;
			font-size: 14px;

			span {
				margin-right: 5px;
			}

			.tips1 {
				color: #FF0000;
			}
		}

		.btn {
			margin-top: 50px;
		}
	}
	.auth_wrap {
		margin-top: 60px;
		padding: 20px 0;
	}

	.auth_1 {
		text-align: center;
		margin-top: 50%;

		p {
			margin-top: 40px;
			font-size: 20px;
			color: green;
			font-weight: bold;
		}
	}

	.tittle_verified {
		margin-top: 10px;
		margin-bottom: 20px;
		font-size: 26px;
	}

	.tittle_verified_tips {
		line-height: 1.5;
	}

	.form {
		width: 100%;
		// margin-top: 65px;
		padding: 0 20px;

		.item {
			width: 100%;
			height: 45px;
			border-radius: 2px;
			border-bottom: 1px solid rgba(0, 0, 0, 0.1);
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin: 10px 0;

			input {
				flex: 1;
				padding: 0 10px;
				height: 22px;
				font-size: 16px;
				line-height: 22px;
			}
		}
	}
	/deep/ .van-uploader__preview-image {
		width: 150px;
		height: 150px;
	}

	/deep/ .van-uploader__upload {
		background-color: unset;
		width: 150px;
		height: 150px;
	}

	// /deep/ .van-uploader {
	// 	background: url(../img/user/qrcode.png) no-repeat center center;
	// 	background-size: auto 60%;
	// 	opacity: 0.2;
	// }

	// /deep/ .van-icon-photograph:before {
	// 	content: unset;
	// }
</style>
